import { Select } from 'antd'
import { SelectProps } from 'antd/lib'
import { useMemo } from 'react'

import { useClassifierServiceGetCountryClassifierElementListEndpoint } from 'src/api/queries'
import { useLocales } from 'src/locales'

export const CountrySelect = (props: SelectProps) => {
  const { data } = useClassifierServiceGetCountryClassifierElementListEndpoint()
  const { currentLang } = useLocales()

  const options = useMemo(() => {
    return data?.data?.map((item) => ({
      value: item.isoCode,
      label: currentLang.value === 'ro' ? item.ro : item.ru
    }))
  }, [data])

  const sortedOptions = useMemo(() => {
    return options?.sort((a, b) => a.label?.localeCompare(b.label ?? '') ?? 0)
  }, [options])

  return (
    <Select
      options={sortedOptions}
      optionFilterProp="label"
      showSearch
      {...props}
    />
  )
}
